import { IonicModule } from '@ionic/angular';
import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ProfilPage } from './profil.page';
import { AboutMeComponent } from './aboutme/aboutMe.component';
import { MainPipe } from '../../services/pipes/main-pipe.module';
import { routes } from './profil.routes';
import { DetaljsidePage } from './editcontact/detaljside.page';
import { editcontactComponent } from './editcontact/editcontact.component';
import { SlettebrukerComponent } from './slettebruker/slettebruker/slettebruker.component';
import { EndrepassordsidePage } from './endrepassord/endrepassordside.page';
import { KundetilgangModal } from '../kundetilgang-modal/kundetilgang-modal.page';
import { ComponentsModule } from '../../shared/components.module';

@NgModule({
  imports: [
    IonicModule,
    CommonModule,
    MainPipe,
    FormsModule,
    ReactiveFormsModule,
    SlettebrukerComponent,
    DetaljsidePage,
    editcontactComponent,
    EndrepassordsidePage,
    KundetilgangModal,
    RouterModule.forChild(routes),
    ComponentsModule
  ],
  declarations: [ProfilPage, AboutMeComponent]
})
export class ProfilPageModule {}
